import axios from '@/mod/axiosMod';

export default {
  /**
   * 获取首页的本月收益和昨日收益
   */
  getHomeIncome() {
    return axios.get('/api/bill/v2/queryHomeIncomeInfo');
  },
  /**
   * 获取首页可提现金额
   */
  getDepositAmount(params) {
    return axios.post('/api/bill/v2/can-withdraw-amount', params);
  },
  /**
   * 获取首页未入账账单数量
   */
  getUndepositBillCount(params) {
    return axios.post('/api/bill/v2/unconfirmed-billcount', params);
  },
  /**
   * 首页提现
   */
  deposit(params) {
    return axios.post('/api/bill/v2/withdraw', params);
  },
  /**
   * 轮询是否可以跳转到金融首页
   */
  getAbleJumpToWallet(params) {
    return axios.post('/api/bill/v2/jump/wallet', params);
  },
  /**
   * 获取账单列表，包括未出账单或者已出账单
   */
  getBillList(params) {
    return axios.post('/api/bill/v2/queryBilledList', params);
  },
  /**
   * 获取月账单列表，包括租宝或者售宝月账单列表
   */
  getMonthBillList(params) {
    return axios.post('/api/bill/v2/monthDivideList', params);
  },
  /**
   * 获取门店的月账单明细，包括门店的租宝或者售宝月账单明细
   */
  getMonthBillDetail(params) {
    return axios.post('/api/bill/v2/monthDivideDetail', params);
  },
  /**
   * 获取门店租宝分成日流水
   */
  getDailyBillDetail(params) {
    return axios.post('/api/bill/v2/rentDailyFlow', params);
  },
  /**
   * 获取已出账单的其他费用类型详情，包括：1：预付款抵扣，2：分期购抵扣，3：成本摊销，4：调整款项
   */
  getOtherExpenseDetail(params) {
    return axios.post('/api/bill/v2/otherExpensesDetail', params);
  },
  /**
   * 已出账单-单月账单-抵扣详情
   */
  getReceivable(params) {
    return axios.post('/api/bill/v2/receivable', params);
  },
  /**
   * 是否存在2021年8月（含）之前的账单（商家、三方）
   */
  getHasHistoryBill(parmas) {
    return axios.post('/api/bill/v2/exist/old-bill', parmas);
  },

  /**
   * 获取合作商活动某月账单
   */
  getAgentActivityBill(params) {
    return axios.post('/api/bill/v2/agreement/list', params);
  },
  /**
   * 获取合作商活动某月某活动账单
   */
  getAgentActivityBillDetail(params) {
    return axios.post('/api/bill/v2/agreement/bill', params);
  },
  /**
   * 获取合作商活动某月某活动月账单
   */
  getAgentActivityMonthBill(params) {
    return axios.post('/api/bill/v2/agreement/monthDivideDetail', params);
  },
  /**
   * 获取合作商活动某月某活动日流水账单
   */
  getAgentActivityDailyBill(params) {
    return axios.post('/api/bill/v2/agreement/rentDailyFlow', params);
  },
  /**
   * 多宝摊销账单
   */
  getAmortizeBill(params) {
    return axios.post('/api/bill/v2/queryChargeWithAdjustment', params);
  },
  /**
   * 合作返点账单
   */
  getCashbackBill(params) {
    return axios.post('/api/bill/v2/queryPartnerRebateDetail', params);
  },
  /**
   * 丢宝找回补款账单
   */
  getInventoryAddBill(params) {
    return axios.post('/api/bill/v2/queryDeviceInvetoryAddList', params);
  },
  /**
   * 优惠券账单
   */
  getCouponBill(params) {
    return axios.post('/api/bill/v2/queryCouponSummary', params);
  },
  /**
   * 优惠券账单明细
   */
  getCouponDetail(params) {
    return axios.post('/api/bill/v2/queryCouponDetail', params);
  },
  /**
   * 电力税补款账单明细
   */
  getTaxRechargeDetail(params) {
    return axios.post('/api/bill/v2/reviseRepairBill', params);
  },
  /**
   * 查询激励账单
   */
  getBonusDetail(params) {
    return axios.post('/api/bill/v2/queryBonusDetail', params);
  },
  /**
   * 查询签约信息
   */
  getSignAndFace() {
    return axios.post('/api/bill/v2/query-payment-contract-data', {});
  },
  /**
   * 发起人脸识别
   */
  signAndFaceVerification(params) {
    return axios.post('/api/bill/v2/sign-and-face-verification', params);
  },
  /**
   * 人脸识别结果查询
   */
  queryFaceVerificationResult(params) {
    return axios.post('/api/bill/v2/query-face-verification-result', params);
  },
  /**
   * 现金奖励激励明细
   *
   */
  queryBonusCashDetail(params) {
    return axios.post('/api/bill/v2/queryBonusCashDetail', params);
  },

  /**
   * 报税信息收集
   */
  collectTaxDeclareInfo(params) {
    return axios.post('/api/bill/v2/tax-declare-info-collect', params);
  },

  /**
   * 查询代扣服务费详情（ID方式）
   * @param id 费用ID
   */
  queryWithholdingFeeDetail(id) {
    return axios.get('/apigw/api/kdb/service/fee/confirm/fee/detail', {
      params: { id },
    });
  },

  /**
   * 查询代扣服务费门店列表
   * @param id 费用ID
   * @param pageNum 页码
   * @param pageSize 每页数量
   */
  queryAgentInvoicePoiList(id, pageNum, pageSize) {
    return axios.get('/apigw/api/kdb/service/fee/confirm/poi/list', {
      params: {
        id,
        pageNum,
        pageSize,
      },
    });
  },

  /**
   * 确认代扣服务费
   * @param id 费用ID
   */
  confirmAgentWithholding(id) {
    return axios.post('/apigw/api/kdb/service/fee/confirmed', { id });
  },
  /* 开票查询 */
  queryAgentInvoiceInfo(agentPartnerId) {
    return axios.get('/apigw/api/kdb/agent/invoice/query', {
      params: { agentPartnerId },
    });
  },

  /**
   * 设备运营服务费返还明细
   */
  queryServiceFeeRefundDetail(params) {
    return axios.post('/api/bill/v2/queryServiceFeeRefundDetail', params);
  },
};
